import { MenuPreviewPage } from "@/features/menu-preview/pages/MenuPreviewPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/menu-preview/")({
	component: MenuPreviewPage,
});
